// extracted by mini-css-extract-plugin
export var actionButton = "_x1-2";
export var card = "_x1-0";
export var errorCard = "_x1-3";
export var row = "_x1-1";